import type { InquiryPayload } from '@/types'

/** Sends a conversation or form submission to the site's inquiry route. Safe to call from the browser. */
export const submitInquiry = async (payload: InquiryPayload): Promise<void> => {
    const response = await fetch('/api/inquiries', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    })

    if (response.ok) return

    const data = await response.json().catch(() => null) as { message?: string } | null

    throw new Error(data?.message ?? "We couldn't send that just now.")
}
